import FilterChip from 'components/Luxkit/Chips/FilterChip'
import DeprecatedDropdownContainer from 'components/Luxkit/Dropdown/DeprecatedDropdownContainer'
import DeprecatedDropdown from 'components/Luxkit/Dropdown/DeprecatedDropdown'
import LineAngleDownIcon from 'components/Luxkit/Icons/line/LineAngleDownIcon'
import LineAngleUpIcon from 'components/Luxkit/Icons/line/LineAngleUpIcon'
import RadioButtonInput from 'components/Luxkit/RadioButton/RadioButtonInput'
import Group from 'components/utils/Group'
import { replace } from 'connected-react-router'
import { CUSTOMER_RATING_GTE } from 'constants/search'
import { useAppDispatch } from 'hooks/reduxHooks'
import useToggle from 'hooks/useToggle'
import { deleteSearchParams, propertyToDestinationSearch, setSearchParamValue } from 'lib/url/searchUrlUtils'
import React, { useCallback, useMemo } from 'react'

interface Props {
  filters: App.OfferListFilters
  search: string
  label: string
}

function CustomerRatingDropdown(props: Props) {
  const { filters, search, label } = props
  const dispatch = useAppDispatch()
  const [isDropdownOpen, toggleDropDown, , closeDropdown] = useToggle()
  const filterChipRef = React.useRef<HTMLButtonElement>(null)
  const currentCustomerRating = useMemo(() => filters?.customerRatingGte, [filters?.customerRatingGte])

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    if (value === CUSTOMER_RATING_GTE.ANY_RATING.value) {
      dispatch(replace({ search: propertyToDestinationSearch(deleteSearchParams(search, 'customerRatingGte')) }))
    } else {
      dispatch(replace({ search: propertyToDestinationSearch(setSearchParamValue(search, 'customerRatingGte', e.target.value)) }))
    }
  }, [dispatch, search])

  const customerRatingItems = useMemo(
    () => {
      return [
        <RadioButtonInput
          key={CUSTOMER_RATING_GTE.EXCEPTIONAL.label}
          checked={CUSTOMER_RATING_GTE.EXCEPTIONAL.value === currentCustomerRating}
          onChange={onChange}
          name={CUSTOMER_RATING_GTE.EXCEPTIONAL.label}
          value={CUSTOMER_RATING_GTE.EXCEPTIONAL.value}
        >
          {CUSTOMER_RATING_GTE.EXCEPTIONAL.label}
        </RadioButtonInput>,
        <RadioButtonInput
          key={CUSTOMER_RATING_GTE.VERY_GOOD.label}
          checked={CUSTOMER_RATING_GTE.VERY_GOOD.value === currentCustomerRating}
          onChange={onChange}
          name={CUSTOMER_RATING_GTE.VERY_GOOD.label}
          value={CUSTOMER_RATING_GTE.VERY_GOOD.value}
        >
          {CUSTOMER_RATING_GTE.VERY_GOOD.label}
        </RadioButtonInput>,
        <RadioButtonInput
          key={CUSTOMER_RATING_GTE.GOOD.label}
          checked={CUSTOMER_RATING_GTE.GOOD.value === currentCustomerRating}
          onChange={onChange}
          name={CUSTOMER_RATING_GTE.GOOD.label}
          value={CUSTOMER_RATING_GTE.GOOD.value}
        >
          {CUSTOMER_RATING_GTE.GOOD.label}
        </RadioButtonInput>,
        <RadioButtonInput
          key={CUSTOMER_RATING_GTE.ANY_RATING.label}
          checked={CUSTOMER_RATING_GTE.ANY_RATING.value === currentCustomerRating || !currentCustomerRating}
          onChange={onChange}
          name={CUSTOMER_RATING_GTE.ANY_RATING.label}
          value={CUSTOMER_RATING_GTE.ANY_RATING.value}
        >
          {CUSTOMER_RATING_GTE.ANY_RATING.label}
        </RadioButtonInput>,
      ]
    }, [currentCustomerRating, onChange])

  const hasRatingBeenSelected = currentCustomerRating !== CUSTOMER_RATING_GTE.ANY_RATING.value && !!currentCustomerRating

  return (
    <div>
      <FilterChip selected={hasRatingBeenSelected} ref={filterChipRef} size="medium" onClick={toggleDropDown} endIcon={isDropdownOpen ? <LineAngleUpIcon /> : <LineAngleDownIcon />}>
        {label}
      </FilterChip>
      <DeprecatedDropdown triggerRef={filterChipRef} open={isDropdownOpen} position="bottom-start" onClose={closeDropdown}>
        <DeprecatedDropdownContainer>
          <Group direction="vertical" gap={16}>
            {customerRatingItems}
          </Group>
        </DeprecatedDropdownContainer>
      </DeprecatedDropdown>
    </div>
  )
}

export default CustomerRatingDropdown
